import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
	selector: '[appDnd]',
	standalone: false,
})
export class DndDirective {
	@Output() fileDropped = new EventEmitter<FileList>();

	// Dragover listener
	@HostListener('dragover', ['$event']) onDragOver(evt) {
		evt.preventDefault();
		evt.stopPropagation();
	}

	// Dragleave listener
	@HostListener('dragleave', ['$event']) public onDragLeave(evt) {
		evt.preventDefault();
		evt.stopPropagation();
	}

	// Drop listener
	@HostListener('drop', ['$event']) public ondrop(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		console.log(JSON.stringify(`evnt ${evt.dataTransfer.files[0].name}`));
		const files: FileList = evt.dataTransfer.files;
		if (files.length > 0 && files.length < 2) {
			this.fileDropped.emit(files);
		} else {
			console.log('only add one file...');
		}
	}
}
